<template>
  <div v-show="show">
    <FormKit v-if="field.useMultipleFields" type="group" :name="name" :help-position="helpPosition" :help="field.instructions" :label="field.name" :validation="validation">
      <p class="mb-2 text-base font-semibold">{{ field.name }}</p>
      <div class="grid gap-6" :class="{ 'md:grid-cols-2': columnCount === 2, 'md:grid-cols-3': columnCount === 3, 'md:grid-cols-4': columnCount === 4 }">
        <FormieFieldDropdown v-if="prefixField.enabled" :settings="settings" :parent-field="parentField" :field="prefixField" />
        <FormieFieldSingleLineText v-if="firstNameField.enabled" :settings="settings" :parent-field="parentField" :field="firstNameField" />
        <FormieFieldSingleLineText v-if="middleNameField.enabled" :settings="settings" :parent-field="parentField" :field="middleNameField" />
        <FormieFieldSingleLineText v-if="lastNameField.enabled" :settings="settings" :parent-field="parentField" :field="lastNameField" />
      </div>
    </FormKit>
    <FormieFieldSingleLineText v-else :settings="settings" :parent-field="parentField" :field="field" />
  </div>
</template>

<script setup lang="ts">
import { fieldHelpPosition, fieldName, fieldValidationArray, fieldVisible } from '~/assets/formie'

interface Props {
  settings: object
  parentField?: object
  field: object
}

const props = defineProps<Props>()

const columnCount = [props.field.prefixEnabled, props.field.firstNameEnabled, props.field.middleNameEnabled, props.field.lastNameEnabled].filter((enabled) => enabled).length
const helpPosition = fieldHelpPosition(props.settings, props.field)
const name = fieldName(props.field)
const show = fieldVisible(props.field)
const validation = fieldValidationArray(props.field)

const prefixField = {
  defaultValue: props.field.prefixDefaultValue,
  enabled: props.field.prefixEnabled,
  errorMessage: props.field.prefixErrorMessage,
  name: props.field.predixLabel,
  options: props.field.prefixOptions,
  placeholder: props.field.prefixPlaceholder,
  required: props.field.prefixRequired,
  handle: 'prefix',
  __typename: 'Field_Dropdown',
}

const firstNameField = {
  defaultValue: props.field.firstNameDefaultValue,
  enabled: props.field.firstNameEnabled,
  errorMessage: props.field.firstNameErrorMessage,
  name: props.field.firstNameLabel,
  placeholder: props.field.firstNamePlaceholder,
  required: props.field.firstNameRequired,
  handle: 'firstName',
  __typename: 'Field_SingleLineText',
}

const middleNameField = {
  defaultValue: props.field.middleNameDefaultValue,
  enabled: props.field.middleNameEnabled,
  errorMessage: props.field.middleNameErrorMessage,
  name: props.field.middleNameLabel,
  placeholder: props.field.middleNamePlaceholder,
  required: props.field.middleNameRequired,
  handle: 'middleName',
  __typename: 'Field_SingleLineText',
}

const lastNameField = {
  defaultValue: props.field.lastNameDefaultValue,
  enabled: props.field.lastNameEnabled,
  errorMessage: props.field.lastNameErrorMessage,
  name: props.field.lastNameLabel,
  placeholder: props.field.lastNamePlaceholder,
  required: props.field.lastNameRequired,
  handle: 'lastName',
  __typename: 'Field_SingleLineText',
}
</script>
